export default __webpack_public_path__ + "static/media/lotus-dark-bold.a2066369.svg";